import { colors } from './tokens.colors';

const track = colors.neutralVariant[50];
const thumb = colors.neutralVariant[400];

// Este objeto SOLO define la "piel" del scrollbar. NO define overflow, ni
// maxHeight, ni maxWidth. Se mergea directo en la definición de un
// styled()/sx de quien lo use (antes era un hook de makeStyles que devolvía
// una clase - F5-7/F5-8, migración MUI v4->v5).
const uikitScrollStyle = {
  /* Chrome, Edge, Safari */
  '&::-webkit-scrollbar': {
    width: 6,
    height: 6,
  },
  '&::-webkit-scrollbar-button': {
    display: 'none',
  },
  '&::-webkit-scrollbar-button:start': {
    width: 0,
    height: 0,
    display: 'none',
  },
  '&::-webkit-scrollbar-button:end': {
    width: 0,
    height: 0,
    display: 'none',
  },
  '&::-webkit-scrollbar-button:single-button': {
    width: 0,
    height: 0,
    display: 'none',
  },

  '&::-webkit-scrollbar-track': {
    background: track,
    borderRadius: 3,
  },
  '&::-webkit-scrollbar-thumb': {
    background: thumb,
    borderRadius: 3,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: thumb,
  },

  /* Firefox */
  // scrollbarWidth: 'thin',
  // scrollbarColor: `${thumb} ${track}`,
} as const;

export default uikitScrollStyle;
